module.exports = __webpack_public_path__ + "static/media/cq_firma_documento.ac43beb6.svg";